/**
 * SAB-952: the shell shared by the draft-room toolbar's two switch controls —
 * AutoDraftControl and HideDraftedControl.
 *
 * ── WHY THESE ARE CONSTANTS AND NOT COPIED CLASS STRINGS ────────────────────
 *
 * SAB-950's whole point is that the two read as siblings: in V2 they sit adjacent in the
 * centre toolbar, and two neighbouring toggles that are visibly different KINDS of thing is
 * the defect it fixed. They had identical class strings in two files, which is a sibling
 * relationship held together by nothing. SAB-952 then had to change both at once — the first
 * time that latent duplication cost anything. Extracted so the next size or colour change
 * cannot silently apply to one of them.
 *
 * ── THE MOBILE SIZING, AND THE FLOOR IT CANNOT GO BELOW ─────────────────────
 *
 * index.css:410 gives `button, a, [role="button"]` a `min-height: 44px` under
 * `@media (max-width: 768px)`. A Radix Switch renders a `<button role="switch">`, so on
 * mobile the switch is pinned to 44px whatever these classes say. Measured: 44px on mobile,
 * 27px on desktop, from the same `h-6`.
 *
 * That is correct and must stay — SAB-871 shipped 41px segments once and had to correct
 * them — but it means the container's floor on mobile is 44 + borders, and ONLY the padding,
 * gap, icon and label can shrink. Shrinking the switch is not available, and the `[data-compact]`
 * escape hatch two lines below that rule in index.css must NOT be used here: it would drop
 * the tap target under 44px, which is the one thing SAB-952 forbids.
 *
 * Measured with a real inset (Emulation.setSafeAreaInsetsOverride, 47/34):
 *   before   390 and 430: 59.5px tall
 *   after    390 and 430: 50.5px tall, switch still 44px
 *   desktop  43px, unchanged
 */

/** Container. Mobile is the base; `md:` restores the desktop values, which were correct. */
export const TOOLBAR_CONTROL_SHELL =
  'flex flex-none items-center gap-1.5 md:gap-2 rounded-[10px] border px-2 md:px-2.5 py-0.5 md:py-1.5';

/** Leading icon — the third channel after colour and wording. */
export const TOOLBAR_CONTROL_ICON = 'h-3 w-3 md:h-3.5 md:w-3.5 flex-none';

/** Label. Stays uppercase and bold at both sizes; only the size changes. */
export const TOOLBAR_CONTROL_LABEL =
  'font-display text-[10px] md:text-[11px] font-bold uppercase tracking-[0.04em] whitespace-nowrap';
